import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { db } from 'firebase/firebase';
import { collection, orderBy, query } from 'firebase/firestore';

import useFirestoreQueryBatched from './useFirestoreQueryBatched/useFirestoreQueryBatched';

const useGetEventTypes = (shouldFetch = true, divIdOrIds) => {
  const orgId = useSelector(state => state.organizations.organization.id);
  const selectedDivsIds = useSelector(({ divisions }) => divisions.selector.ids);

  const divIds = useMemo(() => {
    return divIdOrIds
      ? (Array.isArray(divIdOrIds) ? divIdOrIds : [divIdOrIds]).filter(Boolean)
      : null;
  }, [divIdOrIds]);

  let queriesList = useMemo(() => {
    return divIds?.length
      ? divIds.map(id =>
          query(
            collection(db, 'organizations', orgId, 'divisions', id, 'event_types'),
            orderBy('createdAt'),
          ),
        )
      : selectedDivsIds.map(id =>
          query(
            collection(db, 'organizations', orgId, 'divisions', id, 'event_types'),
            orderBy('createdAt'),
          ),
        );
  }, [divIds, orgId, selectedDivsIds]);

  if (shouldFetch) {
    if (divIds?.length) {
      queriesList = divIds.map(id =>
        query(
          collection(db, 'organizations', orgId, 'divisions', id, 'event_types'),
          orderBy('createdAt'),
        ),
      );
    } else {
      queriesList = selectedDivsIds.map(id =>
        query(
          collection(db, 'organizations', orgId, 'divisions', id, 'event_types'),
          orderBy('createdAt'),
        ),
      );
    }
  }

  const { data, loading } = useFirestoreQueryBatched(queriesList, [selectedDivsIds, divIds]);

  return {
    data,
    loading,
  };
};

export default useGetEventTypes;
